module.exports = __webpack_public_path__ + "static/3-2c0409fb1803dfb387bbe6398da9a994.png";